import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentCtx = createContext({ content: {}, instagram: [], servicePricing: [], previewMode: false });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [instagram, setInstagram] = useState([]);
  const [servicePricing, setServicePricing] = useState([]);
  const [previewMode, setPreviewMode] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content`).then((r) => setContent(r.data || {})).catch(() => {});
    axios.get(`${API}/instagram`).then((r) => setInstagram(r.data || [])).catch(() => {});
    axios.get(`${API}/service-pricing`).then((r) => setServicePricing(r.data || [])).catch(() => {});

    // If we're rendered inside the admin preview iframe, listen for live updates
    const inIframe = window.parent && window.parent !== window;
    if (inIframe) {
      const onMsg = (e) => {
        if (!e.data || typeof e.data !== "object") return;
        if (e.data.type === "RMM_PREVIEW_CONTENT" && e.data.content) {
          setPreviewMode(true);
          setContent(e.data.content);
        }
        if (e.data.type === "RMM_PREVIEW_INSTAGRAM" && Array.isArray(e.data.instagram)) {
          setInstagram(e.data.instagram);
        }
        if (e.data.type === "RMM_PREVIEW_SERVICE_PRICING" && Array.isArray(e.data.servicePricing)) {
          setServicePricing(e.data.servicePricing);
        }
      };
      window.addEventListener("message", onMsg);
      try { window.parent.postMessage({ type: "RMM_PREVIEW_READY" }, "*"); } catch (_) {}
      return () => window.removeEventListener("message", onMsg);
    }
  }, []);

  return (
    <ContentCtx.Provider value={{ content, instagram, servicePricing, previewMode }}>
      {children}
    </ContentCtx.Provider>
  );
}

export const useContent = () => useContext(ContentCtx);
